import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Stethoscope, Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", category: "", pathologies: "", city: "", state: "AM", phone: "", address: "", accepts_diamante: true, discount_percent: 20, description: "" };

export default function GestorRede() {
  const [partners, setPartners] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/partners").then(r=>setPartners(r.data));
  useEffect(()=>{ load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/partners", {
        ...form,
        pathologies: form.pathologies ? form.pathologies.split(",").map(s=>s.trim()).filter(Boolean) : [],
        discount_percent: parseFloat(form.discount_percent || 0),
      });
      toast.success("Credenciado cadastrado!");
      setForm(empty); setShowForm(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Remover credenciado?")) return;
    await api.delete(`/partners/${id}`);
    toast.success("Removido");
    load();
  };

  return (
    <div className="space-y-6" data-testid="gestor-rede-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-black text-[#0E2A5C] flex items-center gap-2"><Stethoscope className="h-7 w-7" /> Rede Credenciada</h1>
          <p className="text-sm text-slate-500">Gerencie clínicas, laboratórios, farmácias e especialistas</p>
        </div>
        <button onClick={()=>setShowForm(s=>!s)} className="btn-primary text-sm" data-testid="add-partner-button">
          {showForm ? <><X className="h-4 w-4" /> Fechar</> : <><Plus className="h-4 w-4" /> Novo credenciado</>}
        </button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="card-soft p-6 grid sm:grid-cols-2 gap-3" data-testid="partner-form">
          <input required placeholder="Nome" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-name" />
          <input required placeholder="Especialidade" value={form.category} onChange={(e)=>setForm({...form, category: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-category" />
          <input placeholder="Patologias atendidas (separar com vírgula)" value={form.pathologies} onChange={(e)=>setForm({...form, pathologies: e.target.value})} className="sm:col-span-2 px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-pathologies" />
          <input required placeholder="Cidade" value={form.city} onChange={(e)=>setForm({...form, city: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-city" />
          <input placeholder="UF" value={form.state} onChange={(e)=>setForm({...form, state: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-state" />
          <input placeholder="Telefone" value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-phone" />
          <input type="number" placeholder="Desconto (%)" value={form.discount_percent} onChange={(e)=>setForm({...form, discount_percent: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-discount" />
          <input placeholder="Endereço" value={form.address} onChange={(e)=>setForm({...form, address: e.target.value})} className="sm:col-span-2 px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="partner-address" />
          <textarea placeholder="Descrição" value={form.description} onChange={(e)=>setForm({...form, description: e.target.value})} className="sm:col-span-2 px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0] min-h-[80px]" data-testid="partner-description" />
          <label className="sm:col-span-2 inline-flex items-center gap-2 text-sm text-slate-600">
            <input type="checkbox" checked={form.accepts_diamante} onChange={(e)=>setForm({...form, accepts_diamante: e.target.checked})} data-testid="partner-diamante" /> Aceita plano Diamante (com crediário)
          </label>
          <button type="submit" className="btn-primary sm:col-span-2" data-testid="partner-submit">Cadastrar</button>
        </form>
      )}

      <div className="card-soft overflow-hidden">
        <table className="w-full text-sm" data-testid="partners-table">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Nome</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Especialidade</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Cidade</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Desconto</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Diamante</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {partners.map(p => (
              <tr key={p.id} data-testid={`row-partner-${p.id}`}>
                <td className="px-5 py-3 font-semibold text-[#0E2A5C]">{p.name}</td>
                <td className="px-5 py-3">{p.category}</td>
                <td className="px-5 py-3">{p.city}/{p.state}</td>
                <td className="px-5 py-3">{p.discount_percent}%</td>
                <td className="px-5 py-3">{p.accepts_diamante ? <span className="text-emerald-600 font-bold">Sim</span> : <span className="text-slate-400">Não</span>}</td>
                <td className="px-5 py-3 text-right">
                  <button onClick={()=>remove(p.id)} className="text-rose-600 hover:text-rose-800" data-testid={`delete-partner-${p.id}`}><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
            {partners.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-slate-500">Nenhum credenciado cadastrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
